import { Controller } from "@hotwired/stimulus"
import { setHidden } from "../lib/display_toggle"

export default class extends Controller {
  static targets = ["input", "container", "item"]

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()

    if (query === "") {
      this.itemTargets.forEach(item => setHidden(item, false))
      return
    }

    this.itemTargets.forEach(item => {
      const nameElement = item.querySelector('[data-carrier-name]')
      const carrierName = nameElement?.dataset.carrierName || nameElement?.textContent || ''
      const matchesSearch = carrierName.toLowerCase().includes(query)

      setHidden(item, !matchesSearch)
    })
  }

  openExternalLink(event) {
    event.preventDefault()
    event.stopPropagation()
    const url = event.currentTarget.dataset.url
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }
}
